<mobile-page-part noContentMessage="No How Tos Found">

	<div class="info-content" style="min-width: 210px;">
		<small>[Department Selector Goes Here]</small>
	</div>

</mobile-page-part>